import { ICartData, ICartItem } from '../../interfaces';
import ProductPriceFormat from '../../../../products/product-price/product-price-format';
import React from 'react';
import { removeCartItem } from '../../data/data-service';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { getLocalData } from '../../domain/shopping-cart-address-provider';
import { sendGAEvent } from '../../../../../domain/marketing/gtm-provider';
import CartComment from '../step-1/cart-item/cart-comment';
import OverviewTitle from './overview-title';
import { getSelectedCartItems } from '../../data/data-provider';
import { CartSteps } from '../../enums/cart-steps';

interface IStep2OverviewItem {
    cartItem: ICartItem,
}

/**
 * Cart Step 2 Overview Item
 */
const StepOverviewItem = (props: IStep2OverviewItem) => {

    const dispatch = useAppDispatch();
    const cartItem = props.cartItem;

    const cartStep = useAppSelector(store => store.root.cartStep);

    /**
     * Handle remove cart item
     */
    const removeCartItemHandler = async () => {

        const response = await removeCartItem(
            props.cartItem.cartItemGUID,
            getLocalData()
        );

        if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData) return;

        const updatedCartData = response.data.relatedData as ICartData;

        dispatch(
            rootActions.setCartData(updatedCartData)
        );

        sendGAEvent('Remove SKU', `Step ${ cartStep }`);

        // if we're at step 3, and after removing the product --->
        // no active products in cart,
        // or no products at all ---> return to the step 1.
        // https://wavesaudio.atlassian.net/browse/DSWEB-2286
        if(!updatedCartData.cartItems ||
            updatedCartData.cartItems.length <= 0 ||
            getSelectedCartItems(updatedCartData).length <= 0){
            dispatch(
                rootActions.main({
                    cartStep: CartSteps.First,
                })
            );
        }
    };

    return (
       <div className="border-b pb-2 mb-4">
           <div className="text-gray-700 flex items-start">
               <div className="pr-2 flex-1">
                   <OverviewTitle cartItem={ cartItem } qa={ `cart-step${ cartStep }-product-name` }  />
               </div>

               <div
                   className="text-tiny bg-gray-150 text-gray-500 px-2 py-1 mx-2 flex items-center"
                   data-qa={`cart-${ cartStep }-qty-value`}>Qty: { cartItem.skuUnits }</div>

               <div
                   className="text-lg text-right font-bold"
                   data-qa={`cart-${ cartStep }-product-price`}><ProductPriceFormat price={ cartItem.skuPrice } /></div>
           </div>
           { cartItem.cartComment && <CartComment comment={ cartItem.cartComment } classes="text-sm mt-2" /> }

           <button
               type="button"
               onClick={ removeCartItemHandler }
               className="text-sm text-gray-500 underline">Remove</button>
       </div>
    )
};

export default StepOverviewItem;